import { CustomLayoutContext } from "components/CustomLayout";
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import AddMemberModal from "views/JobDetailPage/ListPart/ListHeader/AddMemberModal";
import DeleteProjectModal from "views/ProjectGroupPage/Modals/DeleteProject";
import ProjectSettingModal from "views/ProjectGroupPage/Modals/ProjectSetting";
import LeftPart from "./components/LeftPart";
import RightPart from "./components/RightPart";
import MemberSetting from "views/ProjectPage/Modals/MembersSetting";
import { Grid } from "@mui/material";

const DashboardPresenters = ({ project, status = {} }) => {
  const topbar = document.getElementById("project-topbar");
  const { modalSetting, setModalSetting } = useContext(CustomLayoutContext);
  const history = useHistory();
  const [openModalAlert, setOpenModalAlert] = React.useState({
    isOpen: false,
    props: {},
  });
  const [openModalAddMember, setOpenModalAddMember] = React.useState(false);
  console.log(project, "project drawer");
  // const hasPermisison = get(
  //   viewPermissions.permissions,
  //   [projectId, "update_project"],
  //   false
  // );

  const _handleOpenModal = (type, props) => {
    switch (type) {
      case "ALERT":
        setOpenModalAlert({ isOpen: true, alertProps: props });
        return;
      case "SETTING":
        setModalSetting({
          isOpen: true,
          props: { curProject: project?.project },
        });
        return;
      case "ADD_MEMBER":
        setOpenModalAddMember(true);
        return;
      default:
        return;
    }
  };

  const _handleSetOpenSetting = (value) =>
    setModalSetting((prevState) => ({ ...prevState, isOpen: value }));
  const _handleSetOpenAlert = (value) =>
    setOpenModalAlert((prevState) => ({ ...prevState, isOpen: value }));
  const _handleDeleted = (id) => history.replace(`/projects`);

  return (
    <div>
      <Grid
        container
        spacing={3}
        sx={{
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "20px 10px",
          overflowY: "scroll",
          maxHeight: `calc(100vh - ${topbar?.clientHeight}px)`,
          scrollbarWidth: "thin",
          scrollbarColor: `#CCCCCC #ffffff`,
          "&::-webkit-scrollbar": {
            display: "none",
            width: "6px",
            marginRight: "12px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#CCCCCC",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-track": {
            boxShadow: "none",
          },
        }}
      >
        <Grid
          item
          xs={12}
          style={{
            padding: "30px",
            background: "white",
            borderRadius: "20px",
          }}
        >
          <LeftPart
            projectInfo={project?.project || {}}
            status={status}
            handleOpenModal={_handleOpenModal}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            padding: "30px",
            background: "white",
            borderRadius: "20px",
            marginTop: "20px",
          }}
        >
          <RightPart handleOpenModal={_handleOpenModal} />
        </Grid>
      </Grid>

      {modalSetting.isOpen && (
        <ProjectSettingModal
          open={modalSetting.isOpen}
          setOpen={_handleSetOpenSetting}
          {...modalSetting.props}
        />
      )}

      {openModalAddMember && (
        // <AddMemberModal
        //   isOpen={openModalAddMember}
        //   setOpen={setOpenModalAddMember}
        //   task={openModalAddMember}
        //   members={project?.project?.members || []}
        //   projectActive={project?.project?.id || null}
        // />
        <MemberSetting
          open={openModalAddMember}
          setOpen={setOpenModalAddMember}
          project_id={project?.project?.id}
          project={project?.project}
        />
      )}

      <DeleteProjectModal
        open={openModalAlert.isOpen}
        setOpen={_handleSetOpenAlert}
        projectGroupId={project?.id}
        selectedProject={project?.project}
        doAfterSuccess={_handleDeleted}
      />
    </div>
  );
};

export default DashboardPresenters;
